<template>
  <div class="flex flex-col lg:flex-row items-center gap-9 mb-9">
    <div
      v-for="(item) in items"
      :key="item.heading"
      class="flex justify-center border-2 border-[#F5F5F7] rounded-md shadow-md w-full lg:w-1/2 lg:h-full"
    >
      <div class="flex flex-col lg:flex-row justify-center items-center py-7 px-10 lg:p-5 lg:mx-8">
        <div class="mb-6 p-1 flex justify-center lg:mb-0 lg:mr-8 shrink-0">
          <span :class="[item.iconClass, '!w-16 !h-16']" />
        </div>
        <div>
          <p
            class="font-bold mb-2.5 text-center lg:text-left"
          >
            {{ item.heading }}
          </p>
          <p>
            {{ item.text }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import type { DeliveryCardItem } from '~~/types/deliveryCard/DeliveryCardItem';
import isString from '~~/helpers/dataStructure/isString';

export default defineComponent({
  name: 'DeliveryCards',
  props: {
    items: {
      type: Array as PropType<DeliveryCardItem[]>,
      required: true,
      validator: (items: DeliveryCardItem[]): boolean => {

        return items.every((item) => {

          return isString(item.text) &&
          isString(item.heading) &&
          isString(item.iconClass);
        
        });
      
      },
    },
  },
});
</script>
